export default __webpack_public_path__ + "static/media/error-notification.95ce3bb1.svg";